export enum NavigationMenuId {
  Accounting = 'accounting',
  AnnualReports = 'annualReports',
  BankAccounts = 'bankAccounts',
  Banking = 'banking',
  BankingReact = 'bankingReact',
  CashPilot = 'cashpilot',
  BankTransactions = 'bankTransactions',
  Clients = 'clients',
  Creditors = 'creditors',
  Daybook = 'daybook',
  Debtors = 'debtors',
  DeliveryNotes = 'deliveryNotes',
  Documents = 'documents',
  Estimates = 'estimates',
  Expenses = 'expenses',
  ExpertDocuments = 'expertDocuments',
  ExpertMyClient = 'expertMyClient',
  ExpertReports = 'expertReports',
  ExpertReportsSuppliersBalance = 'expertReportsSuppliersBalance',
  ExpertReportsCustomersBalance = 'expertReportsCustomersBalance',
  ExpertReportsTrialBalance = 'expertReportsTrialBalance',
  ExpertReportsProfitAndLoss = 'expertReportsProfitAndLoss',
  ExpertReportsBalanceSheet = 'expertReportsBalanceSheet',
  ExpertReportsVatDeclarations = 'expertReportsVatDeclarations',
  ExpertReviewEntries = 'expertReviewEntries',
  ExportData = 'exportData',
  Financials = 'financials',
  GetALoan = 'getALoan',
  ImportedInvoices = 'importedInvoices',
  Invoices = 'invoices',
  LedgerEntries = 'ledgerEntries',
  LegacyRecurringInvoices = 'legacyRecurringInvoices',
  NoBankAccounts = 'noBankAccounts',
  Overview = 'overview',
  Payroll = 'payroll',
  Products = 'products',
  Purchases = 'purchases',
  QuickStart = 'quickStart',
  Receipts = 'receipts',
  Reconciliation = 'reconciliation',
  RecurringInvoices = 'recurringInvoices',
  Reports = 'reports',
  Sales = 'sales',
  SalesReport = 'salesReport',
  Suppliers = 'suppliers',
  ThingsToDo = 'thingsToDo',
  VatDeclarations = 'vatDeclarations',
  Vouchers = 'vouchers',
}
